import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Briefcase, Wallet, User, Crown, X, AlertTriangle } from 'lucide-react';
import Swal from 'sweetalert2';
import AppContext from '../../../../context/AppContext';
import KycRequiredModal from '../kycrequired/KycRequiredModal';


const WorkerBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showKycModal, setShowKycModal] = useState(false);
  const { kycStatus } = useContext(AppContext);

  const protectedRoutes = [
  
    '/bid-jobs',
    '/worker-earnings',
    '/worker-notifications',
    '/workersubscription',
    '/worker-support',
   
  ];

  const handleNav = (path) => {

    // Allow access to KYC page and FAQ even if KYC is not approved
    if (
      kycStatus !== "approved" &&
      protectedRoutes.includes(path)
    ) {
     setShowKycModal(true);
return;
    }

    navigate(path);
  };

  const isActive = (path) =>
    path === '/worker-dashboard'
      ? location.pathname === '/worker-dashboard'
      : location.pathname.startsWith(path);

  return (
    <>
    <nav className="ws-mob-bottom">
      <button className={"ws-mob-item " + (isActive('/worker-dashboard') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/worker-dashboard')}>
        <Home size={22} /><span>Home</span>
      </button>

      <button className={"ws-mob-item " + (isActive('/workersubscription') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/workersubscription')}>
        <Crown size={22} /><span> Subscription</span>
      </button>
      <button className={"ws-mob-item " + (isActive('/bid-jobs') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/bid-jobs')}>
        <Briefcase size={22} /><span>My Jobs</span>
      </button>
      <button className={"ws-mob-item " + (isActive('/worker-earnings') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/worker-earnings')}>
        <Wallet size={22} /><span>Earnings</span>
      </button>
      <button className={"ws-mob-item " + (isActive('/worker-profile') ? 'ws-mob-item--active' : '')} onClick={() => handleNav('/worker-profile')}>
        <User size={22} /><span>Profile</span>
      </button>
    </nav>
    <KycRequiredModal
  isOpen={showKycModal}
  onClose={() => setShowKycModal(false)}
  onCompleteKyc={() => {
    setShowKycModal(false);
    navigate("/worker-kyc");
  }}
/>
</>
  );
};

export default WorkerBottomNav;